module.exports = __webpack_public_path__ + "static/hometohome-49b5459a420e57e290bf7c6ffc2843ec.webp";